<template>
    <div class="unit mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="unit != '' ? 'border-primary' : ''" type="text" id="inputUnit"
                v-model="unit" @focus="$emit('update:error', '')"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': unit != ''
                }">Đơn vị (Cái, chiếc,...)</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            unit: ''
        }
    },
    watch: {
        data(val){
            this.unit = val;
        },
        unit(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.unit = this.data;
    }
}
</script>
